import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apriComeLaStruttura } from "../../../../components/Util/vistaStruttura";
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import DEFAULT_STRUTTURA from "../../../../../images/DEFAULT_STRUTTURA.png";

import { conMotivo } from "../../../../components/Util/erroreServer";
// Valori del filtro a bottoni: '' vuol dire "tutti".
const STATO_OPTIONS = ['Attivo', 'Non attivo'];

export const AdminUserCoursesTeamsTable = () => {
	const navigate = useNavigate();

	const [data_json, setDataJson] = useState(null);
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label),
			),
		[data_json, statoFilter],
	);

	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

	const [loadingShowed, setLoadingShowed] = useState(false);
	
	// La squadra si apre con la pagina della struttura, come la vede lei, in sola lettura (vistaStruttura.js)
	function openDetail(row) {
		apriComeLaStruttura(navigate, { clubId: row.clubId, nome: row.clubName, percorso: `/struttura/corsi/squadre/${row.id}` });
	}
	
	const data_column = [
		{
			Header: 'Struttura',
			accessor: 'clubName',
			Cell: ({ row }) => {
				return (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							src={row.original.imageUrlClub ? row.original.imageUrlClub : DEFAULT_STRUTTURA}
							alt={row.original.clubName}
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50%',
								marginRight: '10px'
							}}
						/>
						<div>
							{row.original.clubName}
						</div>
					</div>
				)
			}
		},
		{
			Header: 'Nome Squadra',
			Footer: 'Nome Squadra',
			accessor: 'name',
		},
		{
			Header: 'Coach',
			Footer: 'Coach',
			accessor: 'coachName',
		},
		{
			Header: 'Impianto',
			Footer: 'Impianto',
			accessor: 'venueName',
		},
		{
			Header: 'Membri',
			Footer: 'Membri',
			accessor: 'members',
			disableGlobalFilter: true,
		},
		{
			Header: 'Periodo',
			Footer: 'Periodo',
			accessor: 'period',
			disableGlobalFilter: true,
		},
		{
			Header: 'Orario Settimanale',
			Footer: 'Orario Settimanale',
			accessor: 'weeklySchedule',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div style={{ whiteSpace: 'pre-line' }}>
						{value}
					</div>
				)
			}
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value ? value.class : ''}`}></i>
						{value ? value.label : ''}
					</div>
				)
			},
			disableFilters: true,
		},
	];
	
	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [bookingCourseTeams] = await Promise.all([
                        apiClient.getBookingCourseTeams(token)
                    ]);
					setLoadingShowed(false);

					if(bookingCourseTeams) {
						let data = [];
						bookingCourseTeams.forEach(element => {
							const formatWeeklySchedule = (weeklySchedule) => {
								if (!weeklySchedule || weeklySchedule.length === 0) return 'Nessun orario';
								
								const dayNames = {
									'MONDAY': 'Lunedì',
									'TUESDAY': 'Martedì',
									'WEDNESDAY': 'Mercoledì',
									'THURSDAY': 'Giovedì',
									'FRIDAY': 'Venerdì',
									'SATURDAY': 'Sabato',
									'SUNDAY': 'Domenica'
								};
								
								return weeklySchedule.map(schedule => 
									`${dayNames[schedule.dayOfWeek] || schedule.dayOfWeek} ${schedule.startTime}-${schedule.endTime}`
								).join('\n');
							};
							
							const formatDate = (dateString) => {
								if (!dateString) return '-';
								const date = new Date(dateString);
								return date.toLocaleDateString('it-IT', {
									day: '2-digit',
									month: '2-digit',
									year: 'numeric'
								});
							};

							let imageClub = null;
                            if(element.clubPicture) {
								imageClub = element.clubPicture.uri;
							}

							let row = {
								"id": element.id,
								"name": element.name || '-',
								"coachName": element.coachName || '-',
								"imageUrlClub": imageClub,
								"clubName": element.clubName || '-',
								"clubId": element.clubId,
								"venueName": element.venueName || '-',
								"members": `${element.membersIds?.length || 0}/${element.maxMembers}` || '-',
								"period": `${formatDate(element.startDate)} - ${formatDate(element.endDate)}` || '-',
								"weeklySchedule": formatWeeklySchedule(element.weeklySchedule),
								"status": element.status || 'UNKNOWN',
								"status_label": element.status === 'ACTIVE'
									? { label: 'Attivo', class: 'text-success' }
									: element.status === 'INACTIVE'
									? { label: 'Non attivo', class: 'text-warning' }
									: { label: element.status || 'Sconosciuto', class: 'text-secondary' },
							};
							data.push(row);
						});
						setDataJson(data);
					} else {
						setModalTitle("Errore durante il caricamento");
						setModalText(conMotivo("Si è verificato un errore durante il caricamento dei team"));
						setModalShowed(true);
					}
                } else {
					setModalTitle("Errore di autenticazione");
					setModalText("Token di autenticazione non trovato");
					setModalShowed(true);
				}
            } catch (error) {
                console.error("Error fetching data:", error);
				setLoadingShowed(false);
				setModalTitle("Errore durante il caricamento");
				setModalText(conMotivo("Si è verificato un errore durante il caricamento dei team"));
				setModalShowed(true);
            }
        };

        fetchData();

    }, []);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<TabellaLista
				pageList={true}
				cardTitle={'Squadre'}
				hasSearch={true}
				searchPlaceholder={'Cerca per struttura, squadra, coach o impianto'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				data_column={data_column}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				data_json={filteredData}
				hasAddMore={false}
				linkAddMore={'/superadmin/booking/userCoursesTeams/new'}
				labelAddMore={'Aggiungi Squadra'}
				sort_by={'name'}
                sort_type={'asc'}
			/>
		</>
	)
}
export default AdminUserCoursesTeamsTable;